if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    connectedCallback() {
      document.addEventListener("variant:changed", this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener("variant:changed", this.handleVariantChange);
    }

    handleVariantChange(event) {
      const sku = this.querySelector("[data-product-details-sku]");
      const variant = event.detail && event.detail.variant;

      if (sku && variant) {
        sku.textContent = variant.sku || "Nu se aplică";
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
